module.exports = __webpack_public_path__ + "static/media/18.678a9da5.jpg";